<template>
  <g>
    <text transform="matrix(1 0 0 1 300 230)" class="name">전원공급기{{number}}</text>
  <g transform="scale(1.3)">
    <g>
    <path class="st0" d="M297.93,409.85h-34.87c-1.57,0-2.83-1.27-2.83-2.83v-7.73c0-1.57,1.27-2.83,2.83-2.83h34.87
      c1.57,0,2.83,1.27,2.83,2.83v7.73C300.76,408.58,299.49,409.85,297.93,409.85z"/>
    <path class="st0" d="M577,409.85h-36.51c-1.57,0-2.83-1.27-2.83-2.83v-7.83c0-1.57,1.27-2.83,2.83-2.83H577
      c1.57,0,2.83,1.27,2.83,2.83v7.83C579.83,408.58,578.56,409.85,577,409.85z"/>
    <path class="st1" d="M608.88,399.51H232.64c-1.66,0-3-1.34-3-3V187.99c0-1.66,1.34-3,3-3h376.24c1.66,0,3,1.34,3,3v208.51
      C611.88,398.16,610.53,399.51,608.88,399.51z"/>
    <path class="st2" d="M312.97,326.99h-71.66c-3.13,0-5.67-2.54-5.67-5.67V204.43c0-3.13,2.54-5.67,5.67-5.67h71.66
      c3.13,0,5.67,2.54,5.67,5.67v116.89C318.64,324.45,316.1,326.99,312.97,326.99z"/>
    <rect x="296" y="339.21" class="st3" width="297.77" height="49.63"/>
    <rect x="329.64" y="301.15" class="st4" width="183" height="23.84"/>
    <path class="st2" d="M600.97,326.99h-71.68c-3.13,0-5.67-2.54-5.67-5.67V204.86c0-3.13,2.54-5.67,5.67-5.67h71.68
      c3.13,0,5.67,2.54,5.67,5.67v116.46C606.64,324.45,604.1,326.99,600.97,326.99z"/>
    <g>
      <g>
        <rect x="230.64" y="330.99" class="st4" width="381" height="0.7"/>
      </g>
    </g>
  </g>
  <!-- Display -->
  <g class="display">
    <rect x="329.4" y="201.43" class="st5" width="182.71" height="93.16"/>
    <!-- CH1 -->
    <g v-if="on">
      <text transform="matrix(1 0 0 1 440 240)" class="name">{{attr.v1}}V</text>
      <text transform="matrix(1 0 0 1 440 280)" class="name">{{attr.a1}}A</text>
      <!-- CH2 -->
      <text transform="matrix(1 0 0 1 360 240)" class="name">{{attr.v2}}V</text>
      <text transform="matrix(1 0 0 1 360 280)" class="name">{{attr.a2}}A</text>
    </g>
  </g>
  <g>
    <rect x="315.48" y="345.08" class="st6" width="54.7" height="8.27"/>
    <text transform="matrix(1 0 0 1 322.0509 351.582)"><tspan x="0" y="0" class="st7 st8 st9">-    </tspan><tspan x="15.29" y="0" class="st7 st10 st9">CH2    </tspan><tspan x="33.42" y="0" class="st7 st8 st9">+</tspan></text>
  </g>
  <g>
    <rect x="266.21" y="307.71" class="st6" width="24.16" height="8.27"/>
    <text transform="matrix(1 0 0 1 272.5431 313.2598)" class="st7 st10 st9">CH2</text>
  </g>
  <g>
    <rect x="549.86" y="308.15" class="st6" width="24.16" height="8.27"/>
    <text transform="matrix(1 0 0 1 556.1954 313.6914)" class="st7 st10 st9">CH1</text>
  </g>
  <g>
    <circle :class="{'st11':on}" cx="302.7" cy="256.69" r="3.7"/>
    <text transform="matrix(1 0 0 1 298.1125 251.4746)"><tspan x="0" y="0" class="st12 st10 st13">c.v</tspan><tspan x="0" y="14.12" class="st14 st10 st13">c.c</tspan></text>
  </g>
  <g>
    <circle :class="{'st15':on}" cx="533.32" cy="260.26" r="3.7"/>
    <text transform="matrix(1 0 0 1 528.7365 255.0488)"><tspan x="0" y="0" class="st12 st10 st13">c.v</tspan><tspan x="0" y="14.12" class="st14 st10 st13">c.c</tspan></text>
  </g>
  <g>
    <ellipse :class="{'st15':on}" cx="376.28" cy="313.86" rx="3.7" ry="4.14"/>
    <text transform="matrix(0.8948 0 0 1 384.131 315.7334)" class="st16 st10 st17">ON/OFF</text>
  </g>
  <text transform="matrix(0.8948 0 0 1 437.3146 316.0664)" class="st18 st10 st17">TRACKING</text>
  <g>
    <rect x="383.25" y="345.08" class="st6" width="32.46" height="8.27"/>
    <text transform="matrix(1 0 0 1 392.4035 351.6924)" class="st7 st10 st9">GND</text>
  </g>
  <g>
    <rect x="432.4" y="345.08" class="st6" width="54.7" height="8.27"/>
    <text transform="matrix(1 0 0 1 438.9699 351.582)"><tspan x="0" y="0" class="st7 st8 st9">-    </tspan><tspan x="15.29" y="0" class="st7 st10 st9">CH1    </tspan><tspan x="33.42" y="0" class="st7 st8 st9">+</tspan></text>
  </g>
  <g>
    <rect x="512.07" y="344.77" class="st6" width="54.7" height="8.27"/>
    <text transform="matrix(1 0 0 1 518.6407 351.2783)"><tspan x="0" y="0" class="st7 st8 st9">-    </tspan><tspan x="15.29" y="0" class="st7 st10 st9">CH3    </tspan><tspan x="33.42" y="0" class="st7 st8 st9">+</tspan></text>
  </g>
  <text transform="matrix(1 0 0 1 326.465 385.0293)" class="st18 st10 st9">0-30V/0-5A</text>
  <text transform="matrix(1 0 0 1 442.3947 385.0283)" class="st18 st10 st9">0-30V/0-5A</text>
  <text transform="matrix(1 0 0 1 530.6876 384.1465)" class="st18 st10 st9">5V/1A</text>
  <!-- CH2 M2 -->
  <g class="pin">
    <circle class="st18" cx="326.26" cy="367.41" r="10.11"/>
    <circle class="st19" cx="326.26" cy="367.41" r="7.92"/>
    <circle class="st20" cx="326.26" cy="367.41" r="4.95"/>
    <circle
      class="pin-cover terminal"
      cx="326.26"
      cy="367.41"
      r="3.38"
      :id="`${pincode}M2`"
      @click="onClick(`${pincode}M2`)"
    />
  </g>
  <!-- CH2 P2 -->
  <g class="pin">
    <circle class="st14" cx="358.79" cy="367.65" r="10.07"/>
    <circle class="st19" cx="358.79" cy="367.65" r="7.89"/>
    <circle class="st20" cx="358.79" cy="367.65" r="4.93"/>
    <circle
      class="pin-cover terminal"
      cx="358.79"
      cy="367.65"
      r="3.37"
      :id="`${pincode}P2`"
      @click="onClick(`${pincode}P2`)"
    />
  </g>
  <!-- GND -->
  <g class="pin">
    <circle class="st22" cx="399.48" cy="367.62" r="9.43"/>
    <circle class="st19" cx="399.48" cy="367.62" r="7.39"/>
    <circle class="st20" cx="399.48" cy="367.62" r="4.62"/>
    <circle class="st6 disable" cx="399.48" cy="367.62" r="3.15"/>
  </g>
  <!-- CH1 MS -->
  <g class="pin">
    <circle class="st18" cx="442.53" cy="367.08" r="10.11"/>
    <circle class="st19" cx="442.53" cy="367.08" r="7.92"/>
    <circle class="st20" cx="442.53" cy="367.08" r="4.95"/>
    <circle
      class="pin-cover terminal"
      cx="442.53"
      cy="367.08"
      r="3.38"
      :id="`${pincode}M1`"
      @click="onClick(`${pincode}M1`)"
      />
  </g>
  <!-- CH1 P1 -->
  <g class="pin">
    <circle class="st14" cx="475.07" cy="367.31" r="10.07"/>
    <circle class="st19" cx="475.07" cy="367.31" r="7.89"/>
    <circle class="st20" cx="475.07" cy="367.31" r="4.93"/>
    <circle
      class="pin-cover terminal"
      cx="475.07"
      cy="367.31"
      r="3.37"
      :id="`${pincode}P1`"
      @click="onClick(`${pincode}P1`)"
      />
  </g>
  <!-- CH3 -->
  <g class="pin">
    <circle class="st18" cx="522.28" cy="367.21" r="10.11"/>
    <circle class="st19" cx="522.28" cy="367.21" r="7.92"/>
    <circle class="st20" cx="522.28" cy="367.21" r="4.95"/>
    <circle class="st6 disable" cx="522.28" cy="367.21" r="3.38"/>
  </g>
  <g class="pin">
    <circle class="st14" cx="554.82" cy="367.44" r="10.07"/>
    <circle class="st19" cx="554.82" cy="367.44" r="7.89"/>
    <circle class="st20" cx="554.82" cy="367.44" r="4.93"/>
    <circle class="st6 disable" cx="554.82" cy="367.44" r="3.37"/>
  </g>
  <!-- Power button -->
  <g>
    <g>
      <rect x="251.64" y="375.86" class="st6" width="24.16" height="8.27"/>
      <text transform="matrix(1 0 0 1 252.7287 382.1758)" class="st7 st10 st9">POWER</text>
    </g>
    <rect
      x="252.04"
      y="352.02"
      :class="{'on': on, 'st23': !on,}"
      @click.stop="power()"
      width="22.98"
      height="16.12"/>
  </g>
  <!-- CH2 Voltage -->
  <g class="btn" @click="setValueBox('v2')">
    <text transform="matrix(1 0 0 1 260.5724 211.0176)" class="st12 st10 st24">VOLTAGE</text>
    <circle class="st25" cx="277.53" cy="232.62" r="17"/>
    <circle class="st25" cx="277.53" cy="232.62" r="17"/>
    <circle class="st26" cx="277.53" cy="232.62" r="18.11"/>
    <circle class="st27" cx="277.92" cy="232.82" r="12.27"/>
    <line class="st28" x1="277.98" y1="225.31" x2="277.86" y2="214.51"/>
  </g>
  <!-- CH1 Volatage -->
  <g class="btn" @click="setValueBox('v1')">
    <text transform="matrix(1 0 0 1 544.2257 211.4492)" class="st12 st10 st24">VOLTAGE</text>
    <circle class="st25" cx="562.16" cy="233.3" r="17"/>
    <circle class="st25" cx="562.16" cy="233.3" r="17"/>
    <circle id="vo1-bound" class="st26" cx="562.16" cy="233.3" r="18.11"/>
    <g ref="vol1">
      <circle
        class="st29"
        cx="562.55"
        cy="233.5"
        r="12.27"/>
      <line
        class="st28"
        x1="562.61"
        y1="225.99"
        x2="562.49"
        y2="215.19"/>
    </g>
  </g>
  <!-- CH2 Current -->
  <g class="btn" @click="setValueBox('a2')">
    <text transform="matrix(1 0 0 1 259.5666 302.2666)" class="st12 st10 st24">CURRENT</text>
    <circle class="st25" cx="278.15" cy="274.29" r="17"/>
    <circle class="st25" cx="278.15" cy="274.29" r="17"/>
    <circle class="st30" cx="278.15" cy="274.29" r="18.11"/>
    <circle class="st31" cx="278.53" cy="274.49" r="12.27"/>
    <line class="st32" x1="278.59" y1="266.98" x2="278.47" y2="256.18"/>
  </g>
  <!-- CH1 Current -->
  <g class="btn" @click="setValueBox('a1')">
    <g>
      <text transform="matrix(1 0 0 1 543.2198 302.6992)" class="st12 st10 st24">CURRENT</text>
      <circle class="st25" cx="562.15" cy="274.29" r="17"/>
      <circle class="st25" cx="562.15" cy="274.29" r="17"/>
      <circle class="st30" cx="562.15" cy="274.29" r="18.11"/>
      <circle class="st29" cx="562.53" cy="274.49" r="12.27"/>
    </g>
    <line class="st32" x1="562.59" y1="266.98" x2="562.47" y2="256.18"/>
  </g>
  <path class="st23" d="M360.14,318.49h-3c-2.21,0-4-1.79-4-4v-2.26c0-2.21,1.79-4,4-4h3c2.21,0,4,1.79,4,4v2.26
    C364.14,316.7,362.35,318.49,360.14,318.49z"/>
  <path class="st23" d="M426.28,318.15h-3c-2.21,0-4-1.79-4-4v-2.26c0-2.21,1.79-4,4-4h3c2.21,0,4,1.79,4,4v2.26
    C430.28,316.36,428.48,318.15,426.28,318.15z"/>
  <path class="st23" d="M484.28,318.15h-3c-2.21,0-4-1.79-4-4v-2.26c0-2.21,1.79-4,4-4h3c2.21,0,4,1.79,4,4v2.26
    C488.28,316.36,486.48,318.15,484.28,318.15z"/>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  name: 'Powersupply',
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      code: '',
      on: false,
      timemax: null,
      mouse: {
        x: 0,
        y: 0
      },
      attr: {
        v1: 0,
        v2: 0,
        a1: 0,
        a2: 0
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
    // this.setRotateEvent()
  },
  computed: {
    values () {
      return store.state.elct.using.PW[this.data.id]
    }
  },
  methods: {
    onClick (pin) {
      window.event.stopPropagation()
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
    },
    power () {
      window.event.stopPropagation()
      this.on = !this.on
    },
    updateRotate () {
      const dx = this.mouse.x - this.$refs.vol1.cx
      const dy = this.mouse.y - this.$refs.vol1.cy
      const transform = 'rotate(' + Math.atan2(dy, dx) + 'rad)'
      this.$refs.vol1.style.transform = transform
    },
    setValueBox (unit) { // name 'v1', 'v2', 'a1', 'a2'
      window.event.stopPropagation()
      if (!this.on) return
      store.state.valuebox.resist.toggle = false
      const obj = { type: 'values', toggle: true, id: this.data.id, unit, code: this.data.code.name }
      this.$store.commit('setValueBox', obj)
    },
    setRotateEvent () {
      window.event.stopPropagation()
      // const rotationSnap = 20
      window.gsap.set(this.$refs.vol1, { transfromOrigin: '50% 50%' })
      const dg = window.Draggable.create(this.$refs.vol1, {
        type: 'rotation',
        throwProps: true
      })
      console.log(dg)
    }
  }
}
</script>

<style lang="scss" scoped>
g.selected {
  path.st1, path.st0{
    stroke-width: 1.5px;
    stroke: #ff6f61;
  }
}
.pin-cover {
    display: block;
    stroke: none;
    fill: black;
    // fill: #887BB0;
}
.pin:hover {
    .pin-cover {
      cursor: pointer;
      stroke-width: 1px;
      stroke: black;
      fill: #ff6f61;
    }
    .disable {
      cursor: not-allowed;
    }
}
.on {
  fill: #ff6f61;
  stroke:#231815;
  stroke-width:0.5;
}

g.display {
  text{
    fill: #248D3A;
    font-size: 30px;
  }
}

.btn:hover {
  cursor: pointer;
}

.highlight {
  -webkit-filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
  filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
}

.st0{fill:#C0BFBF;stroke:#040000;stroke-width:0.5;stroke-miterlimit:10;}
.st1{fill:#E6E4E6;stroke:#323333;stroke-width:0.5;stroke-miterlimit:10;}
.st2{fill:#D8D8DA;}
.st3{fill:#D8D8DA;stroke:#040000;stroke-width:0.25;stroke-miterlimit:10;}
.st4{fill:#C7C9CE;}
.st5{fill:#111314;}
.st6{fill:#5D5C67;}
.st7{fill:#FFFFFF;}
.st8{font-family:'AdobeMyungjoStd-Medium-KSCpc-EUC-H';}
.st9{font-size:7.0622px;}
.st10{font-family:'Calibri';}
.st11{fill:#D8281C;stroke:#070001;stroke-width:0.5;stroke-miterlimit:10;}
.st12{fill:#231815;}
.st13{font-size:7.9449px;}
.st14{fill:#D8281C;}
.st15{fill:#248D3A;stroke:#070001;stroke-width:0.5;stroke-miterlimit:10;}
.st16{fill:#197A3A;}
.st17{font-size:8.8786px;}
.st18{fill:#070001;}
.st19{fill:#070001;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}
.st20{fill:#070001;stroke:#FFFFFF;stroke-miterlimit:10;}
.st21{fill:#FDFEFE;}
.st22{fill:#1E6E37;}
.st23{fill:#A7A9A7; stroke:#231815;stroke-width:0.5;stroke-miterlimit:10;}
.st23:hover { cursor: pointer; fill: #ff6f61;}
.st24{font-size:9.2233px;}
.st25{fill:none;stroke:#231815;stroke-miterlimit:10;}
.st26{fill:#BABAB9;}
.st27{fill:none;stroke:#040000;stroke-width:0.25;stroke-miterlimit:10;}
.st28{fill:none;stroke:#8D8987;stroke-width:2;stroke-miterlimit:10;}
.st29{fill:none;stroke:#090103;stroke-width:0.25;stroke-miterlimit:10;}
.st30{fill:#949EA1;}
.st31{fill:none;stroke:#070102;stroke-width:0.25;stroke-miterlimit:10;}
.st32{fill:none;stroke:#5B5F63;stroke-width:2;stroke-miterlimit:10;}
</style>
